export const ErrorIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    height="18"
    width="18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 0a9 9 0 109 9 9.01 9.01 0 00-9-9zm-.692 4.846a.692.692 0 111.384 0v4.846a.692.692 0 11-1.384 0V4.846zm.692 9a1.039 1.039 0 110-2.077 1.039 1.039 0 010 2.077z"
      fill="#F53C14"
    />
  </svg>
);
